__webpack_require__.p = "/programming-digital-humanities/";